// Rishab code
import { SelectBox, TextBox, Button } from "devextreme-react";
import React, { useState, useEffect } from "react";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import CustomDropdown from "../../../components/customDropDown/CustomDropdown";
import CancelSaveHeader from "../../../components/customPageHeader/CancelSaveHeader";
import CustomOtpPopup from "../../../components/customPopup/CustomOtpPopup";
import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import {
  customer_edit,
  getCustomerByCodeApi,
  requestAddressFromPin,
} from "../../../api/companyCustomerApi";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { useLocation, useNavigate } from "react-router-dom";
import { getCountryState } from "../../../api/companyCustomerApi";
import { custStatusDataSource2, typeOptions, yesnoDataSource } from "../data";
import { LoadPanel } from "devextreme-react";
import { validateEmail } from "../../../components/login-form/LoginForm";
import { generateOtpWithAction } from "../../../api/forgotPwdApi";
import { getCategoryData } from "../../../api/settingsApi";
import AddNewSubHeader from "../../../components/customPageHeader/SaveNewHeader";

export default function EditCustomerPage() {
  const [loading, setLoading] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    custcode: "",
    custname: "",
    custemail: "",
    cntctname: "",
    // custpassword: "",
    // password: "",
    custphno: "",
    custstatus: "",
    custtype: "",
    custgstno: "",
    custregaddr: "",
    custcity: "",
    custpincode: "",
    custstate: "",
    custcountry: "",
    custisdeleted: 0,
    // companytransid: 8,
    companytransid: "",
    custlogo: "",
    // passwordreq: "changed",
    isotpverified: "N",
    show_working_hrs: "",
  });

  const [isEditOtpPopupVisible, setisEditOtpPopupVisible] = useState(false);
  const location = useLocation();
  const { custcode } = location.state || {};
  const [chkOtpVerify, setChkOtpVerify] = useState("N");
  const [pinCodeRect, setPinCodeRect] = useState(true);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoading(true);
        const response = await getCountryState();
        const countriesList = response.data.map((country) => ({
          text: country.name,
          value: country.name,
          states: country.states, // Include states for later use
        }));
        setCountries(countriesList);
      } catch (error) {
        ToastDisplayer("error", error?.response?.data?.msg);
      } finally {
        setLoading(false);
      }
    };
    fetchCountries();
  }, []);

  // Fetch states based on the selected country
  useEffect(() => {
    // Populate states based on the initially selected country or user-selected country
    const currentCountry = selectedCountry || formData.custcountry;

    if (currentCountry) {
      const countryData = countries.find(
        (country) => country.value === currentCountry,
      );
      if (countryData) {
        const stateList = countryData.states.map((state) => ({
          text: state.name,
          value: state.name,
        }));
        setStates(stateList);

        // Preselect the state if it's already in formData
        if (formData.custstate) {
          setSelectedState(formData.custstate);
        }
      }
    }
  }, [countries, selectedCountry, formData.custcountry, formData.custstate]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await getCategoryData();
        const categoryData = response.data.map((category) => ({
          value: category.ticketcategoryname,
          text: category.ticketcategoryname,
        }));
        setCategories(categoryData);
      } catch (error) {
        ToastDisplayer("error", "Failed to fetch categories");
      }
    };
    fetchCategories();
  }, []);

  // Use the custcode to fetch customer data and update the form
  useEffect(() => {
    if (custcode) {
      // Fetch customer data using the custcode
      const fetchCustomerDetails = async () => {
        try {
          setLoading(true);
          const response = await getCustomerByCodeApi(custcode);
          setFormData((prevFormData) => ({
            ...prevFormData,
            custcode: response.data.data.custcode || prevFormData.custcode,
            custname: response.data.data.custname || prevFormData.custname,
            custemail: response.data.data.custemail || prevFormData.custemail,

            // ...(response.data.passwordreq !== "pending" && {
            //   password: response.data.custpassword || prevFormData.password,
            // }),

            cntctname: response.data.data.cntctname || prevFormData.cntctname,
            custphno: response.data.data.custphno || prevFormData.custphno,
            custstatus:
              response.data.data.custstatus || prevFormData.custstatus,
            custgstno: response.data.data.custgstno || prevFormData.custgstno,
            custregaddr:
              response.data.data.custregaddr || prevFormData.custregaddr,
            custcity: response.data.data.custcity || prevFormData.custcity,
            custpincode:
              response.data.data.custpincode || prevFormData.custpincode,
            custstate: response.data.data.custstate || prevFormData.custstate,
            custcountry:
              response.data.data.custcountry || prevFormData.custcountry,
            custisdeleted:
              response.data.data.custisdeleted || prevFormData.custisdeleted,
            companytransid:
              response.data.data.companytransid || prevFormData.companytransid,
            custlogo: response.data.data.custlogo || prevFormData.custlogo,
            // passwordreq:
            //   response.data.data.passwordreq || prevFormData.passwordreq,
            isotpverified:
              response.data.data.isotpverified || prevFormData.isotpverified,
            show_working_hrs:
              response.data.data.show_working_hrs ||
              prevFormData.show_working_hrs,
          }));
        } catch (error) {
          console.error("Failed to fetch customer data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchCustomerDetails();
    }
  }, [custcode]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.custname?.trim())
      newErrors.custname = "Client name is required.";
    if (!formData.custemail?.trim()) {
      newErrors.custemail = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.custemail)) {
      newErrors.custemail = "Invalid email format.";
    }

    // if (formData.passwordreq === "pending") {
    //   if (!formData.password?.trim()) {
    //     newErrors.password = "Password is required.";
    //   } else if (formData.password?.trim() && formData.password.length > 15)
    //     newErrors.password = "Password must not be greater 15 characters";
    // }

    if (formData.custgstno?.length !== 15) {
      newErrors.custgstno = "GST number must be exactly 15 characters.";
    }
    if (!formData.show_working_hrs)
      newErrors.show_working_hrs =
        "Please select if Total Work Hours should be shown for this customer.";
    if (!formData.custregaddr?.trim())
      newErrors.custregaddr = "Address is required.";
    if (!formData.custcity?.trim()) newErrors.custcity = "City is required.";
    if (!formData.custpincode) {
      newErrors.custpincode = "Pin code is required.";
    } else if (!/^\d{6}$/.test(formData.custpincode)) {
      newErrors.custpincode = "Pin code must be 6 digits.";
    } else if (!pinCodeRect) {
      newErrors.custpincode = "Please enter valid pincode!";
    }
    if (!formData.custcountry?.trim())
      newErrors.custcountry = "Country is required.";
    if (!formData.custstatus?.trim())
      newErrors.custstatus = "Status Type is required.";
    if (!formData.custstate?.trim()) newErrors.custstate = "State is required.";

    setErrors(newErrors);
    Object.values(newErrors).forEach((error) => {
      ToastDisplayer("error", error);
    });

    return Object.keys(newErrors).length === 0;
  };

  const handleEditDetails = async () => {
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    // if (formData.custpassword?.trim() && formData.passwordreq === "pending") {
    //   formData.passwordreq = "changed";
    // }

    const modifiedFormData = {
      ...formData,
      custstatus:
        formData.custstatus === "A"
          ? "active"
          : formData.custstatus === "I"
            ? "inactive"
            : formData.custstatus,
      isotpverified: formData.isotpverified === "Y" ? "Y" : chkOtpVerify,
    };
    // if (formData.password?.trim() && formData.passwordreq === "pending") {
    //   modifiedFormData.custpassword = formData.password;
    //   modifiedFormData.passwordreq = "changed";
    // }
    try {
      const response = await customer_edit(formData.custcode, modifiedFormData);
      ToastDisplayer("success", "Client details updated successfully!");
      navigate("/client");
    } catch (error) {
      ToastDisplayer("error", "Failed to update customer details.");
    } finally {
      setLoading(false);
    }
  };

  const toggleOtpPopup = () => {
    setisEditOtpPopupVisible(!isEditOtpPopupVisible);
  };

  // const handleCustOtpPopup = async () => {
  //   try {
  //     const trimmedEmail = formData?.custemail.trim();
  //     if (!trimmedEmail || !validateEmail(trimmedEmail)) {
  //       return ToastDisplayer(
  //         "error",
  //         !trimmedEmail
  //           ? "Email address cannot be empty."
  //           : "Please enter a valid email address.",
  //       );
  //     }

  //     setLoading(true);

  //     // const result = await generateOtpWithAction(formData?.custemail, "C");
  //     // if (result?.data) {
  //     //   ToastDisplayer("success", result.data.message);
  //     //   setisEditOtpPopupVisible(!isEditOtpPopupVisible);
  //     // }
  //   } catch (error) {
  //     ToastDisplayer("error", error.response.data.error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleInputChange = (field) => (e) => {
    const value = e && (e.value || e.target?.value || " ");
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: undefined,
    }));
  };

  const handleStateChange = (value) => {
    setSelectedState(value);
    setFormData((prev) => ({
      ...prev,
      custstate: value, // Sync state selection to formData
    }));
  };

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
    const countryData = countries.find((country) => country.value === value);
    if (countryData) {
      const stateList = countryData.states.map((state) => ({
        text: state.name,
        value: state.name,
      }));
      setStates(stateList); // Populate states based on selected country
    }
    setFormData((prev) => ({
      ...prev,
      custcountry: value,
      custstate: "", // Reset state if country changes
    }));
  };

  const handelCancelButton = () => {
    navigate(-1);
  };

  const handleGetAddress = async (pinCode) => {
    setLoading(true);
    if (pinCode.length === 6) {
      const getAddress = await requestAddressFromPin(pinCode);
      if (getAddress.length === 0 || getAddress[0].Status === "Error") {
        setLoading(false);
        setPinCodeRect(false);
        return;
      } else {
        setPinCodeRect(true);
        const add = getAddress[0].PostOffice[0];
        setFormData((prev) => {
          return {
            ...prev,
            custcountry: add.Country,
            custstate: add.State,
            custcity: add.District,
          };
        });
      }
    }
    setLoading(false);
  };

  const handleSelectBoxChange = (field) => {
    return (e) => {
      const newValue = e.value;
      setFormData((prev) => {
        return {
          ...prev,
          [field]: newValue,
        };
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: undefined,
      }));
    };
  };
  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="addCustPage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-edit-line"></i>
              </span>
              {/* <p>Edit Client</p> */}
              <BreadCrumb />
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Cancel"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handelCancelButton}
            />

            <Button
              className="saveBtn"
              text="Save Details"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleEditDetails}
            />

            {/* <CustomPageHeader
              // titleName={"Customers"}
              handleCreateNew={handleCreateNew}
              btnText={"Add Client"}
            /> */}
          </div>
        </div>
        {/* <AddNewSubHeader
          titleName={"Edit Customer"}
          handleSaveDetails={handleEditDetails}
          handleCancel={handelCancelButton}
          cancelText={"Cancel"}
          saveText={"Save Details"}
          iconClass={"ri-edit-line"}
        /> */}
        <div className="customerMain middlePart">
          <div className="mainAddCustSection">
            <CustomTextBox
              label="Client Code"
              placeholder="What's the code?"
              value={formData.custcode}
              readOnly
              type="text"
            />
            <CustomTextBox
              label="Client Name"
              placeholder="What's the name?"
              value={formData?.custname}
              onChange={handleInputChange("custname")}
              type="text"
            />
            <div className="MyTextBox">
              <label className="TextBoxLabel">
                Email Address <span className="requiredClass">*</span>
              </label>
              <div className="TextBoxWrapper">
                <TextBox
                  value={formData.custemail}
                  onValueChanged={handleInputChange("custemail")}
                  width={"100%"}
                  readOnly
                  stylingMode="outlined"
                  className="TextBoxMain"
                  placeholder="What's email address?"
                  mode="text"
                />
                {/* <span className="email-arrow-icon" onClick={handleCustOtpPopup}>
                  <i className="ri-arrow-right-line"></i>
                </span> */}
              </div>
            </div>
            {/* {formData.passwordreq === "pending" ? (
              <CustomTextBox
                label="Password"
                placeholder="Change Password"
                type="password"
                value={formData.password}
                onChange={handleInputChange("password")} // Pass the field name to handleInputChange
              />
            ) : (
              <CustomTextBox
                label="Password"
                placeholder="Password not required"
                type="password"
                readOnly
              />
            )} */}

            <CustomDropdown
              label={"Status"}
              myDataSource={custStatusDataSource2}
              value={formData.custstatus || null} // 👈 IMPORTANT
              setSelectedValue={(selectedItem) => {
                setFormData((prev) => ({
                  ...prev,
                  custstatus: selectedItem?.value,
                }));
              }}
            />
          </div>
          <div className="mainAddCustSection">
            <CustomTextBox
              label="Contact Person Name"
              placeholder="Contact Person Name"
              value={formData.cntctname}
              onChange={handleInputChange("cntctname")}
              type="text"
            />

            <CustomTextBox
              label="Contact Number"
              placeholder="Contact Number"
              value={formData.custphno}
              onChange={handleInputChange("custphno")}
              type="text"
            />

            <CustomDropdown
              // label={"Want to show Total Work Hours for this customer?"}
              label={"Show total work hours?"}
              myDataSource={yesnoDataSource}
              placeholder={formData.show_working_hrs}
              setSelectedValue={handleInputChange("show_working_hrs")}
            />
          </div>
          <div className="mainAddCustSection">
            <CustomTextBox
              label="GST Number"
              placeholder="GST Number"
              value={formData.custgstno}
              onChange={handleInputChange("custgstno")}
              type="text"
            />

            <CustomTextBox
              label="Registered Address"
              placeholder="Company Address"
              value={formData.custregaddr}
              onChange={handleInputChange("custregaddr")}
              type="text"
            />

            {/* <CustomTextBox
              label="Pin Code"
              placeholder="Enter Pin Code"
              value={formData.custpincode}
              onChange={handleInputChange("custpincode")}
              type="text"
            /> */}

            <div className="MyTextBox">
              <label className="TextBoxLabel">
                Pin Code <span className="requiredClass">*</span>
              </label>
              <div className="TextBoxWrapper">
                <TextBox
                  stylingMode="outlined"
                  className="TextBoxMain"
                  value={formData?.custpincode}
                  onValueChange={handleGetAddress}
                  onValueChanged={handleInputChange("custpincode")}
                  placeholder="Enter Pin Code"
                />
              </div>
            </div>

            <CustomTextBox
              label="City"
              placeholder="Enter City"
              value={formData.custcity}
              onChange={handleInputChange("custcity")}
              type="text"
              readOnly
            />

            <CustomTextBox
              label="State"
              placeholder="Enter State"
              value={formData.custstate}
              onChange={handleInputChange("custstate")}
              type="text"
              readOnly
            />

            <CustomTextBox
              label="Country"
              placeholder="Enter Country"
              value={formData.custcountry}
              onChange={handleInputChange("custcountry")}
              type="text"
              readOnly
            />

            {/* <div className="MyDropDown">
              <label className="ddLabel">
                Country
                <span className="requiredClass">*</span>
              </label>
              <div className="ddWrapper">
                <SelectBox
                  className="ddMain"
                  stylingMode="outlined"
                  placeholder="Select Country"
                  items={countries}
                  value={formData?.custcountry}
                  displayExpr="value"
                  onValueChanged={handleSelectBoxChange("custcountry")}
                  valueExpr="value"
                />
              </div>
            </div> */}

            {/* <div className="MyDropDown">
              <label className="ddLabel">
                State
                <span className="requiredClass">*</span>
              </label>
              <div className="ddWrapper">
                <SelectBox
                  className="ddMain"
                  stylingMode="outlined"
                  placeholder="Select State"
                  items={states}
                  value={formData?.custstate}
                  displayExpr="value"
                  onValueChanged={handleSelectBoxChange("custstate")}
                  valueExpr="value"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <CustomOtpPopup
        visible={isEditOtpPopupVisible}
        onClose={toggleOtpPopup}
        emailOtp={formData?.custemail}
        setLoading={setLoading}
        setChkOtpVerify={setChkOtpVerify}
      />
    </>
  );
}
